<template>
    <div class='container'>
        <div class="top">
            <el-radio-group v-model="scope" @change="radioChange">
                <el-radio-button label="1">日汇总</el-radio-button>
                <el-radio-button label="2">月汇总</el-radio-button>
            </el-radio-group>
            <span class="date-title">日期选择：</span>
            <el-date-picker
            v-model="daterange"
            :type="dateRangeType"
            size="small"
            align="right"
            unlink-panels
            range-separator="至"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="datePickerChanged"
            :picker-options="pickerOptions">
            </el-date-picker>
            <span class="statistics-title">商品统计方式：</span>
            <span class="statistics-mode" @click="dataListTypeChange(statisticsMode ? 0 : 1)">
                <span :class="statisticsMode === 0 ? 'isActived' : ''">名称</span>
                <span :class="statisticsMode === 1 ? 'isActived' : ''">类目</span>
            </span>
        </div>
        <el-table v-loading="isLoading"
            v-textHighlight="{
                keyword: searchWord,
                indexs: [1],
                isBegin: !isLoading
            }"
            style="width: 100%"
            ref="elTable"
            :data="tableData"
            :height="'calc(100vh - 195px)'"
            :empty-text="isLoading ? ' ' : '暂无数据'"
            @sort-change="sortChange">
            <el-table-column
                type="index"
                min-width="50">
            </el-table-column>
            <el-table-column
                min-width="160">
                <template v-slot:header="{ row }">
                    <table-data-search 
                        :title="statisticsMode === 0 ? '全部商品' : '全部类目'"
                        :placeholder="'搜索'"
                        ref="tableDataSearch"
                        @search="searchGoods"/>
                </template>
                <template slot-scope="scope">
                    <span v-if="statisticsMode === 0" class="text-popper" v-textPopper>
                        <router-link class="href" :to="'/main/goodsLibrary/goodsDetail?id=' + scope.row.goods.id">{{ scope.row.goods.name }}</router-link>
                    </span>
                    <span v-else class="text-popper" v-textPopper>
                        {{scope.row.goods_category.name}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                prop="net_sales_income"
                align="right"
                min-width="160"
                label="有效销售额(元)"
                sortable="custom">
                <template slot-scope="scope">
                    <span class="text-popper pr-20" v-textPopper v-numberAlign>{{ scope.row.net_sales_income }}</span>
                </template>
            </el-table-column>
            <el-table-column
                prop="net_order_count"
                min-width="160"
                align="right"
                label="有效销售笔数"
                sortable="custom">
                <template slot-scope="scope">
                    <span :class="['text-popper', 'pr-20', scope.row.net_order_count < 0 ? 'color-red' : '']" v-textPopper >{{ scope.row.net_order_count }}</span>
                </template>
            </el-table-column>
            <el-table-column
                align="right"
                prop="net_sales_count"
                min-width="120"
                label="销售量"
                sortable="custom">
                <template v-slot="{ row }">
                    <span :class="['text-popper', 'pr-20', row.net_sales_count < 0 ? 'color-red' : '']" v-textPopper>{{ row.net_sales_count }}{{ get(row, 'sales_unit_name') }}</span>
                </template>
            </el-table-column>
            <el-table-column min-width="80"/>
            <el-table-column
                v-if="statisticsMode === 0"
                prop="address"
                width="80"
                label="操作">
                <template slot-scope="{ row }">
                    <button class="pl-0 text-btn" @click="$router.push('/main/goodsLibrary/goodsDetail?id=' + row.goods.id)">详情</button>
                </template>
            </el-table-column>
            <p v-if="tableData.length > 0 && !isLoading" slot="append" style="text-align: center; padding: 10px;">没有更多了</p>
        </el-table>
    </div>
</template>

<script lang='ts'>
import { createComponent, ref, onBeforeMount, watch, computed, onMounted } from '@vue/composition-api'
import { $fetch } from '@/api'
import { openMessage, useScrollLoad } from '@/utils/system.tsx'
import { getOneMonthValue } from '@/utils/index'
import dayJs from 'dayjs'
import QuestionIcon from '@/components/question_icon/question_icon.vue'
import { setObjectItemToFixed } from '@/utils/index'
import TableDataSearch from '@/components/table_data_search/table_data_search.vue'
import get from 'lodash/get'
import { mount } from '@vue/test-utils'

export default createComponent({
    data() {
        return {
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                    const end = new Date()
                    const start = new Date()
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                    picker.$emit('pick', [start, end])
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                    const end = new Date()
                    const start = new Date()
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                    picker.$emit('pick', [start, end])
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                    const end = new Date()
                    const start = new Date()
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                    picker.$emit('pick', [start, end])
                    }
                }]
            },
        }
    },
    setup(props, ctx) {
        const scope = ref(1)
        const daterange = ref(getOneMonthValue())
        const tableData = ref([])
        const isLoading = ref(false)
        const searchWord = ref('')
        const statisticsMode = ref<number>(0)

        let changedOne = false
        let changedTwo = false
        let oOrderingType: number | undefined
        let oOrderingDesc: boolean | undefined
        const orderingTypeMap = {
            goods_id: 0,
            category_id: 1,
            net_sales_income: 2,
            net_order_count: 3,
            net_sales_count: 4
        }
        const orderingDescMap = {
            descending: false,
            ascending: true
        }
        // const { bindListener, isLoading } = useScrollLoad()

        const dateRangeType = computed(() => {
            return +scope.value === 1 ? 'daterange' : 'monthrange'
        })

        onMounted(()=> {
            window.location.href = 'https://ls.senguo.cc/newadmin/#/main/data/goodsSale'
        })

        watch([scope], () => {
            if (+scope.value === 1 && !changedOne) {
                daterange.value = [dayJs().toDate(), dayJs().toDate()]
            }
            if (+scope.value === 2 && !changedTwo) {
                daterange.value = (getOneMonthValue(true) as any[]).map((val, i) => {
                    if (i === 0) {
                        return dayJs(val).date(1).add(1, 'month').toDate()
                    } else {
                        return dayJs(val).date(1).toDate()
                    }
                })
            }
        })

        watch([statisticsMode], () => {
            getTableData()
        })

        function getTableData(keyword: string = searchWord.value, orderingType: number | undefined = oOrderingType, orderingDesc: boolean | undefined = oOrderingDesc) {
            let dateParams = {}
            const oneMonthVal = getOneMonthValue(true)

            if (+scope.value === 1) {
                if (changedOne) {
                    dateParams = {
                        from_date: dayJs(daterange.value[0] as any).format('YYYY-MM-DD'),
                        to_date: dayJs(daterange.value[1] as any).format('YYYY-MM-DD')
                    }
                } else {
                    dateParams = {
                        from_date: dayJs().format('YYYY-MM-DD'),
                        to_date: dayJs().format('YYYY-MM-DD')
                    }
                }
            } else {
                if (changedTwo) {
                    dateParams = {
                        from_date: dayJs(daterange.value[0] as any).date(1).format('YYYY-MM-DD'),
                        before_date: dayJs(daterange.value[1] as any).date(1).add(1, 'month').format('YYYY-MM-DD')
                    }
                } else {
                    dateParams = {
                        from_date: dayJs(oneMonthVal[0]).date(1).add(1, 'month').format('YYYY-MM-DD'),
                        before_date: dayJs(oneMonthVal[1]).date(1).add(1, 'month').format('YYYY-MM-DD')
                    }
                }
            }
            isLoading.value = true
            return $fetch.post({
                url: "/finance/getgoodssalesstatistics",
                params: {
                    statistics_methods: statisticsMode.value,
                    scope: scope.value,
                    keyword: keyword || undefined,
                    ordering_type: orderingType,
                    ordering_desc: orderingDesc,
                    ...dateParams
                }
            }).then(data => {
                tableData.value = []
                ctx.root.$nextTick(() => {
                    // 清空列表，防止element-ui对第一行复用产生bug
                    tableData.value = data
                })
                return data
            }).catch(e => {
                openMessage("error", e.message)
            }).finally(() => {
                isLoading.value = false
            })
        }

        const datePickerChanged = () => {
            if (+scope.value === 1) {
                !changedOne && (changedOne = true)
            } else {
                !changedTwo && (changedTwo = true)
            }
            getTableData()
        }

        const radioChange = () => {
            getTableData()
        }

        const dataListTypeChange = (type: number) => {
            (ctx.refs.tableDataSearch as any).clear()
            statisticsMode.value = type
        }

        const searchGoods = (newVal) => {
            console.log(newVal)
            searchWord.value = newVal
            getTableData()
        }

        const sortChange = ({ column, prop, order }) => {
            oOrderingDesc = orderingDescMap[order]
            if (oOrderingDesc == null) {
                oOrderingType = undefined
            } else {
                oOrderingType = orderingTypeMap[prop]
            }
            console.log(oOrderingType, oOrderingDesc)
            getTableData()
        }

        return {
            statisticsMode,
            searchWord,
            scope,
            daterange,
            tableData,
            dateRangeType,
            isLoading,
            datePickerChanged,
            dataListTypeChange,
            searchGoods,
            get,
            sortChange,
            radioChange
        }
    },
    components: {
        QuestionIcon,
        TableDataSearch
    }
})
</script>

<style lang="scss" scoped>
.container {

    .top {
        margin-top: 12px;

        .date-title, .statistics-title {
            margin-left: 20px;
            color: #333333;
            font-size: 14px;
        }

        ::v-deep .el-date-editor {
            display: inline-flex;
            align-items: center;
            width: 236px !important;
            height: 36px;
            margin-right: 12px;
            line-height: 1;

            &.is-clearable {
                width: 252px !important;

                .el-range__close-icon {
                    display: inline-block;
                }
            }

            > * {
                height: auto;
            }

            .el-range-input,
            .el-range-separator {
                font-size: 14px;
            }

            .el-range-separator {
                width: 20px;
                padding: 0 !important;
                margin: 0 !important;
                transform: translateY(1px);
                font-size: 14px;
            }

            .el-range-input::placeholder {
                color: #999;
            }

            .el-range__close-icon {
                display: none;
            }

            .el-input__icon::before {
                font-size: 16px;
            }
        }

        .statistics-mode {
            display: inline-block;
            height: 32px;
            padding: 2px;
            background: #ECECEC;
            border-radius: 14px;

            span {
                display: inline-block;
                width: 60px;
                height: 28px;
                text-align: center;
                line-height: 28px;
                font-size: 12px;
                color: #999;
                border-radius: 14px;
                cursor: pointer;
            }

            .isActived {
                font-size: 14px;
                color: #009688;
                background: #FFF;
            }
        }
    }
}
</style>
